// extracted by mini-css-extract-plugin
export default {"orgIssuesCard":"OrgWithIssues_orgIssuesCard__IUfFn","orgName":"OrgWithIssues_orgName__kZhQq","orgIssuesList":"OrgWithIssues_orgIssuesList__leosh"};